var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCcWorkflowoverviewv2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 2088,
    height: 710,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -376)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250 547.87c33.14 0 60 45.82 60 102.34 0 56.54-26.86 102.36-60 102.36H70c-33.14 0-60-45.82-60-102.35 0-56.5 26.86-102.33 60-102.33z",
    stroke: "#000",
    strokeOpacity: 0,
    strokeWidth: 5,
    fill: "#1071e5"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "matrix(1,0,0,1,15,552.8686628099083) translate(51.54333333333338 85.54)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    transform: "matrix(1,0,0,1,15,552.8686628099083) translate(66.03333333333337 145.54444444444442)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 566.34a8 8 0 0 1 8-8h227.53a8 8 0 0 1 8 8v167.74a8 8 0 0 1-8 8H908a8 8 0 0 1-8-8z",
    stroke: "#000",
    strokeOpacity: 0,
    strokeWidth: 5,
    fill: "#7ab648"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    transform: "matrix(1,0,0,1,905,563.3439773208379) translate(29.022222222222226 76.6)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    transform: "matrix(1,0,0,1,905,563.3439773208379) translate(20.86666666666669 128.77777777777777)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M890 808.43a8 8 0 0 1 8-8h221.18a8 8 0 0 1 8 8v215.8c-39.6-37.37-64.28-37.37-79.22-37.37-23.72 0-55.26 37.38-78.98 37.38-14.7 0-39.6 0-78.98-37.38z",
    stroke: "#fff",
    strokeWidth: 5,
    fill: "#00c2a8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M903.18 828.17a8 8 0 0 1 8-8h221.17a8 8 0 0 1 8 8V1044c-39.6-37.4-64.27-37.4-79.2-37.4-23.73 0-55.28 37.4-79 37.4-14.7 0-39.6 0-78.97-37.4z",
    stroke: "#fff",
    strokeWidth: 5,
    fill: "#00c2a8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M916.35 847.92a8 8 0 0 1 8-8h221.18a8 8 0 0 1 8 8v215.82c-39.6-37.38-64.27-37.38-79.22-37.38-23.7 0-55.25 37.38-78.97 37.38-14.7 0-39.6 0-78.98-37.38z",
    stroke: "#fff",
    strokeWidth: 5,
    fill: "#00c2a8"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    transform: "matrix(1,0,0,1,921.3530079377991,844.922642348324) translate(40.959999999999994 55.66)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f",
    transform: "matrix(1,0,0,1,921.3530079377991,844.922642348324) translate(8.02000000000001 102.61999999999999)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g",
    transform: "matrix(1,0,0,1,921.3530079377991,844.922642348324) translate(59.739999999999995 149.57999999999998)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.3 888a8 8 0 0 1 8-8h227.54a8 8 0 0 1 8 8v167.74a8 8 0 0 1-8 8H473.3a8 8 0 0 1-8-8z",
    stroke: "#000",
    strokeOpacity: 0,
    strokeWidth: 5,
    fill: "#c92d39"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h",
    transform: "matrix(1,0,0,1,470.30961162000153,885) translate(29.022222222222283 76.60000000000001)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#i",
    transform: "matrix(1,0,0,1,470.30961162000153,885) translate(30.97777777777783 128.77777777777777)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.8 971.87H438.6m-24.24 0h-48.47m-24.23 0h-48.47m-24.23 0h-48.47m-24.24 0H172l-1.88-.15-1.83-.44-1.75-.72-1.6-.98-1.44-1.23-1.2-1.43-1-1.6-.7-1.74-.45-1.83-.15-1.88v-30.4m0-30.42v-60.82m0-30.4V777.4",
    stroke: "#c92d39",
    strokeWidth: 5,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.3 974.37h-2.55v-5h2.56z",
    stroke: "#c92d39",
    strokeWidth: 0.05,
    fill: "#c92d39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160 760.65l4.63 14.26h-9.26z",
    stroke: "#c92d39",
    strokeWidth: 5,
    fill: "#c92d39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 967.82a8 8 0 0 1 8-8h429.3a8 8 0 0 1 8 8v87.92a8 8 0 0 1-8 8H48a8 8 0 0 1-8-8z",
    stroke: "#000",
    strokeOpacity: 0,
    strokeWidth: 5,
    fill: "#fff",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#j",
    transform: "matrix(1,0,0,1,45,964.8178809028993) translate(24.263333333333378 61.90444444444444)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#k",
    transform: "matrix(1,0,0,1,45,964.8178809028993) translate(109.34111111111113 61.90444444444444)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    transform: "matrix(1,0,0,1,45,964.8178809028993) translate(193.99666666666667 61.90444444444444)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1158.53 932.3h306.66a12 12 0 0 0 12-12V792",
    stroke: "#4c535d",
    strokeWidth: 5,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1158.6 934.8h-2.57v-5h2.56z",
    stroke: "#4c535d",
    strokeWidth: 0.05,
    fill: "#4c535d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1477.2 775.24l4.62 14.27h-9.27z",
    stroke: "#4c535d",
    strokeWidth: 5,
    fill: "#4c535d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.08 746v109.14",
    stroke: "#c92d39",
    strokeWidth: 5,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.58 746.06h-5v-2.57h5z",
    stroke: "#c92d39",
    strokeWidth: 0.05,
    fill: "#c92d39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.08 871.9l-4.64-14.26h9.27z",
    stroke: "#c92d39",
    strokeWidth: 5,
    fill: "#c92d39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.46 647.87h125.5",
    stroke: "#4c535d",
    strokeWidth: 5,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.53 650.37H310v-1.46l-.12-3.53h2.65z",
    stroke: "#4c535d",
    strokeWidth: 0.05,
    fill: "#4c535d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.72 647.87l-14.27 4.63v-9.27z",
    stroke: "#4c535d",
    strokeWidth: 5,
    fill: "#4c535d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.3 565.25a8 8 0 0 1 8-8h227.54a8 8 0 0 1 8 8V733a8 8 0 0 1-8 8H473.3a8 8 0 0 1-8-8z",
    stroke: "#000",
    strokeWidth: 5,
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#m",
    transform: "matrix(1,0,0,1,470.30961162000153,562.2542512397989) translate(43.37444444444449 75.04)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#n",
    transform: "matrix(1,0,0,1,470.30961162000153,562.2542512397989) translate(37.215555555555596 135.04444444444442)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M713.84 640h161.3",
    stroke: "#7ab648",
    strokeWidth: 5,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M713.9 642.5h-2.56v-5h2.56z",
    stroke: "#7ab648",
    strokeWidth: 0.05,
    fill: "#7ab648"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M891.9 640l-14.26 4.63v-9.26z",
    stroke: "#7ab648",
    strokeWidth: 5,
    fill: "#7ab648"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2021.38 547.87c33.14 0 60 45.82 60 102.34 0 56.54-26.86 102.36-60 102.36h-180c-33.14 0-60-45.82-60-102.35 0-56.5 26.86-102.33 60-102.33z",
    stroke: "#000",
    strokeOpacity: 0,
    strokeWidth: 5,
    fill: "#008a0e"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#o",
    transform: "matrix(1,0,0,1,1786.379619415765,552.8686628099083) translate(16.690000000000055 86.58000000000001)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    transform: "matrix(1,0,0,1,1786.379619415765,552.8686628099083) translate(111.05000000000001 86.58000000000001)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#q",
    transform: "matrix(1,0,0,1,1786.379619415765,552.8686628099083) translate(39.23000000000005 141.36666666666665)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200 440c0 22.1-17.9 40-40 40s-40-17.9-40-40 17.9-40 40-40 40 17.9 40 40z",
    stroke: "#6db1ff",
    strokeWidth: 9,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#r",
    transform: "matrix(1,0,0,1,125,405) translate(22.320666666666675 48.2533333333333)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.43 440c0 22.1-17.9 40-40 40s-40-17.9-40-40 17.9-40 40-40 40 17.9 40 40z",
    stroke: "#6db1ff",
    strokeWidth: 9,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s",
    transform: "matrix(1,0,0,1,549.4270917755038,405) translate(20.524000000000008 48.2533333333333)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1052.8 440c0 22.1-17.9 40-40 40s-40-17.9-40-40 17.9-40 40-40 40 17.9 40 40z",
    stroke: "#6db1ff",
    strokeWidth: 9,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#t",
    transform: "matrix(1,0,0,1,977.793700388756,405) translate(21.29800000000001 46.16444444444441)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1517.2 440c0 22.1-17.92 40-40 40-22.1 0-40-17.9-40-40s17.9-40 40-40c22.08 0 40 17.9 40 40z",
    stroke: "#6db1ff",
    strokeWidth: 9,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#u",
    transform: "matrix(1,0,0,1,1442.1863306070345,405) translate(20.978777777777786 46.16444444444441)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1968.73 440c0 22.1-17.9 40-40 40s-40-17.9-40-40 17.9-40 40-40 40 17.9 40 40z",
    stroke: "#6db1ff",
    strokeWidth: 9,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#v",
    transform: "matrix(1,0,0,1,1893.7320598822719,405) translate(21.39622222222223 46.16444444444441)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1470.7 524.7a11.02 11.02 0 0 1 12.96 0l157.05 113.97a5.8 5.8 0 0 1 0 9.4l-157.04 113.97a11.02 11.02 0 0 1-12.95 0l-157.04-113.97a5.8 5.8 0 0 1 0-9.4z",
    stroke: "#4c535d",
    strokeWidth: 6,
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#w",
    transform: "matrix(1,0,0,1,1312.1863306070345,525) translate(90.83100000000007 87.74666666666661)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#x",
    transform: "matrix(1,0,0,1,1312.1863306070345,525) translate(37.52133333333347 140.18533333333323)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1146.03 640h138.05",
    stroke: "#4c535d",
    strokeWidth: 5,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1146.1 642.5h-2.57v-5h2.56z",
    stroke: "#4c535d",
    strokeWidth: 0.05,
    fill: "#4c535d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1300.85 640l-14.27 4.63v-9.26z",
    stroke: "#4c535d",
    strokeWidth: 5,
    fill: "#4c535d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1647.94 640h108.9",
    stroke: "#008a0e",
    strokeWidth: 5,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1648 642.5h-1.96l-.08-.78-.46-1.6-.75-1.48-.9-1.14h4.15z",
    stroke: "#008a0e",
    strokeWidth: 0.05,
    fill: "#008a0e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1773.62 640l-14.27 4.63v-9.26z",
    stroke: "#008a0e",
    strokeWidth: 5,
    fill: "#008a0e"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M455-710c135 1 191 156 138 280-38 88-109 168-228 168H149L93 0H24l151-710h280zm87 191c0-73-34-129-105-129H231l-69 324h212c105-11 168-88 168-195",
    id: "y"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M156-396c47-65 111-132 213-124l-13 59c-99 5-173 64-211 137L77 0H9l110-521h64",
    id: "z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M335-530c169-5 238 187 171 339C458-83 367 5 220 10 50 15-17-177 50-329c48-108 139-197 285-201zM114-313C65-202 107-46 233-50c107-4 173-76 208-156 49-112 6-268-119-264-107 3-172 77-208 157",
    id: "A"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M262 10c-87 3-139-54-162-118L32 213h-68l156-734h60l-21 101c45-55 117-110 207-110 163 0 222 188 162 338C485-86 402 5 262 10zM115-181c16 73 58 131 141 131 108 0 171-79 206-160 56-132-25-305-178-250-59 21-122 59-135 119",
    id: "B"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M402-170C411 29 84 60-20-68l40-46c45 48 99 72 162 72 88 0 176-56 143-142-56-66-207-47-252-124-6-11-9-25-9-40 0-154 179-216 322-162 29 11 50 30 65 51l-42 40c-25-37-77-60-136-60-80 0-142 33-142 113 0 57 49 55 105 73 86 28 162 33 166 123",
    id: "C"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M464-122C416-49 341 6 226 10 52 15-16-174 49-330c46-110 139-200 290-200 96 0 166 44 166 140 0 51-24 88-68 116-64 40-226 44-341 34-9 112 35 198 142 198 82 0 136-43 170-97zm-21-269c6-90-121-102-193-70-72 31-122 93-145 172 136 4 329 29 338-102",
    id: "D"
  }), /*#__PURE__*/React.createElement("g", {
    id: "a"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.05111111111111108,0,0,0.05111111111111108,0,0)",
    xlinkHref: "#y"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.05111111111111108,0,0,0.05111111111111108,30.615555555555538,0)",
    xlinkHref: "#z"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.05111111111111108,0,0,0.05111111111111108,46.81777777777775,0)",
    xlinkHref: "#A"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.05111111111111108,0,0,0.05111111111111108,76.1044444444444,0)",
    xlinkHref: "#B"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.05111111111111108,0,0,0.05111111111111108,106.41333333333327,0)",
    xlinkHref: "#A"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.05111111111111108,0,0,0.05111111111111108,135.69999999999993,0)",
    xlinkHref: "#C"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.05111111111111108,0,0,0.05111111111111108,159.61999999999992,0)",
    xlinkHref: "#D"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-161 96c26 36 101 26 129-2C-15 77 4 55 9 27l117-548h68L78 23C53 123-34 206-161 172c-18-5-32-16-43-30zm331-826h68l-22 100h-68",
    id: "E"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M457-119C411-47 336 7 223 10 52 14-17-177 50-331c47-109 138-195 287-199 94-3 158 49 176 124l-70 21c-16-79-126-107-205-65-78 42-143 116-143 231 0 96 45 169 138 169 76 0 131-39 161-89",
    id: "F"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M126-128c-35 90 87 78 123 48l6 55C198 17 24 34 51-94l79-373H61l12-54h68l38-176h68l-38 176h114l-12 54H198",
    id: "G"
  }), /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.05111111111111108,0,0,0.05111111111111108,0,0)",
    xlinkHref: "#y"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.05111111111111108,0,0,0.05111111111111108,30.615555555555538,0)",
    xlinkHref: "#z"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.05111111111111108,0,0,0.05111111111111108,46.81777777777775,0)",
    xlinkHref: "#A"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.05111111111111108,0,0,0.05111111111111108,76.1044444444444,0)",
    xlinkHref: "#E"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.05111111111111108,0,0,0.05111111111111108,87.34888888888884,0)",
    xlinkHref: "#D"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.05111111111111108,0,0,0.05111111111111108,114.64222222222214,0)",
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.05111111111111108,0,0,0.05111111111111108,141.52666666666659,0)",
    xlinkHref: "#G"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M455-710c135 1 191 156 138 280-38 88-109 168-228 168H149L93 0H24l151-710h280zm87 191c0-73-34-129-105-129H231l-69 324h212c105-11 168-88 168-195",
    id: "H"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156-396c47-65 111-132 213-124l-13 59c-99 5-173 64-211 137L77 0H9l110-521h64",
    id: "I"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335-530c169-5 238 187 171 339C458-83 367 5 220 10 50 15-17-177 50-329c48-108 139-197 285-201zM114-313C65-202 107-46 233-50c107-4 173-76 208-156 49-112 6-268-119-264-107 3-172 77-208 157",
    id: "J"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262 10c-87 3-139-54-162-118L32 213h-68l156-734h60l-21 101c45-55 117-110 207-110 163 0 222 188 162 338C485-86 402 5 262 10zM115-181c16 73 58 131 141 131 108 0 171-79 206-160 56-132-25-305-178-250-59 21-122 59-135 119",
    id: "K"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402-170C411 29 84 60-20-68l40-46c45 48 99 72 162 72 88 0 176-56 143-142-56-66-207-47-252-124-6-11-9-25-9-40 0-154 179-216 322-162 29 11 50 30 65 51l-42 40c-25-37-77-60-136-60-80 0-142 33-142 113 0 57 49 55 105 73 86 28 162 33 166 123",
    id: "L"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418-101C375-44 299 9 210 10 46 12-13-179 49-328c44-105 126-196 265-202 85-4 140 56 162 118l24-109h68c-31 149-64 295-94 445 0 11 6 16 19 16L480 0c-44 11-85-10-70-58 2-9 4-23 8-43zM114-308C59-175 139-7 292-60c59-21 123-58 135-119l33-161c-10-101-126-165-226-108-53 30-95 81-120 140",
    id: "M"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104-118c-21 67 58 71 100 51l-2 55C132 21 8 18 32-95l134-635h68",
    id: "N"
  }), /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04444444444444444,0,0,0.04444444444444444,0,0)",
    xlinkHref: "#H"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04444444444444444,0,0,0.04444444444444444,26.62222222222222,0)",
    xlinkHref: "#I"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04444444444444444,0,0,0.04444444444444444,40.71111111111111,0)",
    xlinkHref: "#J"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04444444444444444,0,0,0.04444444444444444,66.17777777777778,0)",
    xlinkHref: "#K"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04444444444444444,0,0,0.04444444444444444,92.53333333333332,0)",
    xlinkHref: "#J"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04444444444444444,0,0,0.04444444444444444,118,0)",
    xlinkHref: "#L"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04444444444444444,0,0,0.04444444444444444,138.8,0)",
    xlinkHref: "#M"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04444444444444444,0,0,0.04444444444444444,165.3777777777778,0)",
    xlinkHref: "#N"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M386-710h60L574 0h-74l-39-222H162L30 0h-75zm71 433l-58-351-211 351h269",
    id: "O"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193-63c103-132 191-287 239-458h66C448-346 353-172 214 0h-73L58-521h71",
    id: "P"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464-122C416-49 341 6 226 10 52 15-16-174 49-330c46-110 139-200 290-200 96 0 166 44 166 140 0 51-24 88-68 116-64 40-226 44-341 34-9 112 35 198 142 198 82 0 136-43 170-97zm-21-269c6-90-121-102-193-70-72 31-122 93-145 172 136 4 329 29 338-102",
    id: "Q"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418-101C375-44 299 9 211 10 46 12-13-179 49-328c44-105 127-196 266-202 84-4 139 56 161 118l68-318h68c-46 218-93 434-138 653 0 11 6 17 19 17L480 0c-45 10-84-10-71-58 1-8 4-22 9-43zM114-309C59-176 139-7 292-60c59-21 123-58 135-119l33-161c-10-101-125-165-226-108-54 30-95 80-120 139",
    id: "R"
  }), /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04444444444444444,0,0,0.04444444444444444,0,0)",
    xlinkHref: "#O"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04444444444444444,0,0,0.04444444444444444,28.93333333333333,0)",
    xlinkHref: "#K"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04444444444444444,0,0,0.04444444444444444,55.28888888888887,0)",
    xlinkHref: "#K"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04444444444444444,0,0,0.04444444444444444,81.64444444444443,0)",
    xlinkHref: "#I"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04444444444444444,0,0,0.04444444444444444,95.73333333333332,0)",
    xlinkHref: "#J"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04444444444444444,0,0,0.04444444444444444,120.44444444444443,0)",
    xlinkHref: "#P"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04444444444444444,0,0,0.04444444444444444,141.95555555555552,0)",
    xlinkHref: "#Q"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04444444444444444,0,0,0.04444444444444444,165.68888888888884,0)",
    xlinkHref: "#R"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M58-511c0-144 107-204 253-204 101 0 170 34 227 82l-34 56c-39-44-109-76-194-76-110 0-180 37-180 132 0 108 106 112 197 136 122 32 246 53 246 199C573-44 462 6 317 6 207 6 112-28 32-97l35-57c57 57 139 93 252 98 122 6 215-66 167-178-84-117-345-66-414-204-10-20-14-44-14-73",
    id: "S"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M165-113c-1 73 106 62 142 33l18 55C293-10 255 6 207 6 141 6 97-28 97-94v-373H25v-54h72v-176h68v176h120v54H165v354",
    id: "T"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M455-118C417-47 338 8 238 10 7 15 84-305 70-521h68v294c0 118 40 177 121 177 102 0 156-66 188-143v-328h68v433c0 19 8 28 24 28V0c-48 11-85-12-84-58v-60",
    id: "U"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M483-101C439-16 301 45 189-12 104-55 40-136 40-259c0-155 85-264 238-271 93-4 162 59 197 118v-318h68v642c0 19 8 28 24 28V0c-42 13-84-13-84-50v-51zM110-259c0 122 73 209 194 209 86 0 152-53 171-129v-161c-31-69-87-130-180-130-119 0-185 91-185 211",
    id: "V"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M522-120C485-42 411 10 300 10 138 10 39-100 39-262c0-161 99-268 260-268 168 0 260 118 257 294H110c14 112 76 194 193 194 79 0 133-38 160-94zm-30-168c-9-131-125-225-264-175-69 25-111 88-119 175h383",
    id: "W"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M358-530c125 0 154 99 155 225V0h-68v-291c-1-106-21-177-112-177-102 0-161 68-190 149V0H75v-521h62v118c37-69 120-127 221-127",
    id: "X"
  }), /*#__PURE__*/React.createElement("g", {
    id: "e"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04,0,0,0.04,0,0)",
    xlinkHref: "#S"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04,0,0,0.04,24.04,0)",
    xlinkHref: "#T"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04,0,0,0.04,37.440000000000005,0)",
    xlinkHref: "#U"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04,0,0,0.04,61.2,0)",
    xlinkHref: "#V"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04,0,0,0.04,86.08,0)",
    xlinkHref: "#W"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04,0,0,0.04,109.56,0)",
    xlinkHref: "#X"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04,0,0,0.04,132.68,0)",
    xlinkHref: "#T"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M670-356C670-135 549 0 330 0H89v-710h241c221 6 340 136 340 354zM330-62c179-6 270-115 270-294 0-178-91-287-270-292H159v586h171",
    id: "Y"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M231 0L19-521h70L268-63l180-458h66L302 0h-71",
    id: "Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M179 6C117 6 77-32 78-95v-635h68v612c-6 63 67 74 115 51l12 55c-21 9-65 18-94 18",
    id: "aa"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M556-259c0 160-98 269-259 269S39-99 39-259c0-125 67-206 155-249 61-29 145-29 206 0 89 43 156 123 156 249zM297-470c-119 0-189 90-189 212 0 121 70 208 189 208s190-88 190-210c0-121-71-210-190-210",
    id: "ab"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M577-260c0 156-83 264-236 270-95 4-160-57-198-118v321H75v-734h61v101c45-83 181-146 293-88 84 43 148 126 148 248zm-434 79c33 69 84 131 179 131 119 0 186-90 186-210 0-122-73-210-194-210-87 0-151 54-171 129v160",
    id: "ac"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M139-396c34-70 99-132 196-127v62c-97 3-167 59-192 137V0H75v-521h64v125",
    id: "ad"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M438-202C513-35 297 54 129-10 91-25 57-43 29-68l31-46c52 41 104 69 187 72 88 4 165-51 128-134-69-79-256-49-311-144-7-14-11-31-11-52-9-188 290-194 383-87l-33 40c-59-86-330-92-278 71 72 78 268 45 313 146",
    id: "ae"
  }), /*#__PURE__*/React.createElement("g", {
    id: "f"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04,0,0,0.04,0,0)",
    xlinkHref: "#Y"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04,0,0,0.04,28.6,0)",
    xlinkHref: "#W"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04,0,0,0.04,51.52,0)",
    xlinkHref: "#Z"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04,0,0,0.04,72.12,0)",
    xlinkHref: "#W"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04,0,0,0.04,95.60000000000001,0)",
    xlinkHref: "#aa"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04,0,0,0.04,106.48,0)",
    xlinkHref: "#ab"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04,0,0,0.04,130.28,0)",
    xlinkHref: "#ac"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04,0,0,0.04,154.96,0)",
    xlinkHref: "#W"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04,0,0,0.04,178.44,0)",
    xlinkHref: "#ad"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04,0,0,0.04,192.48000000000002,0)",
    xlinkHref: "#ae"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M309-710h59L663 0h-74l-92-222H178L87 0H12zm172 433L338-628 193-277h288",
    id: "af"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M252 151c-17 51-73 85-147 69v-60c37 4 66 3 79-25 20-43 33-79 58-135L15-521h70L278-63l179-458h65",
    id: "ag"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04,0,0,0.04,0,0)",
    xlinkHref: "#af"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04,0,0,0.04,27.04,0)",
    xlinkHref: "#ac"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04,0,0,0.04,51.72,0)",
    xlinkHref: "#ac"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04,0,0,0.04,76.4,0)",
    xlinkHref: "#aa"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04,0,0,0.04,86.84,0)",
    xlinkHref: "#ag"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M418-101C375-44 299 9 210 10 46 12-13-179 49-328c44-105 126-196 265-202 85-4 140 56 162 118l24-109h68c-31 149-64 295-94 445 0 11 6 16 19 16L480 0c-44 11-85-10-70-58 2-9 4-23 8-43zM114-308C59-175 139-7 292-60c59-21 123-58 135-119l33-161c-10-101-126-165-226-108-53 30-95 81-120 140",
    id: "ah"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M104-118c-21 67 58 71 100 51l-2 55C132 21 8 18 32-95l134-635h68",
    id: "ai"
  }), /*#__PURE__*/React.createElement("g", {
    id: "h"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04444444444444442,0,0,0.04444444444444442,0,0)",
    xlinkHref: "#y"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04444444444444442,0,0,0.04444444444444442,26.622222222222206,0)",
    xlinkHref: "#z"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04444444444444442,0,0,0.04444444444444442,40.71111111111109,0)",
    xlinkHref: "#A"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04444444444444442,0,0,0.04444444444444442,66.17777777777773,0)",
    xlinkHref: "#B"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04444444444444442,0,0,0.04444444444444442,92.53333333333327,0)",
    xlinkHref: "#A"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04444444444444442,0,0,0.04444444444444442,117.99999999999993,0)",
    xlinkHref: "#C"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04444444444444442,0,0,0.04444444444444442,138.79999999999993,0)",
    xlinkHref: "#ah"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04444444444444442,0,0,0.04444444444444442,165.37777777777768,0)",
    xlinkHref: "#ai"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M619-525c0 135-86 220-200 251L526 0h-79L345-262H149L93 0H24l151-710h285c105 6 159 80 159 185zm-72 8c0-73-33-131-104-131H231l-69 324h219c103-11 166-87 166-193",
    id: "aj"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M418-101C375-44 299 9 211 10 46 12-13-179 49-328c44-105 127-196 266-202 84-4 139 56 161 118l68-318h68c-46 218-93 434-138 653 0 11 6 17 19 17L480 0c-45 10-84-10-71-58 1-8 4-22 9-43zM114-309C59-176 139-7 292-60c59-21 123-58 135-119l33-161c-10-101-125-165-226-108-54 30-95 80-120 139",
    id: "ak"
  }), /*#__PURE__*/React.createElement("g", {
    id: "i"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04444444444444442,0,0,0.04444444444444442,0,0)",
    xlinkHref: "#aj"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04444444444444442,0,0,0.04444444444444442,27.422222222222207,0)",
    xlinkHref: "#D"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04444444444444442,0,0,0.04444444444444442,51.15555555555552,0)",
    xlinkHref: "#E"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04444444444444442,0,0,0.04444444444444442,60.933333333333294,0)",
    xlinkHref: "#D"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04444444444444442,0,0,0.04444444444444442,84.66666666666661,0)",
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04444444444444442,0,0,0.04444444444444442,108.04444444444438,0)",
    xlinkHref: "#G"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04444444444444442,0,0,0.04444444444444442,121.73333333333326,0)",
    xlinkHref: "#D"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04444444444444442,0,0,0.04444444444444442,145.46666666666658,0)",
    xlinkHref: "#ak"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M566-62V0H89v-710h468v62H159v256h347v59H159v271h407",
    id: "al"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483-101C439-16 301 45 189-12 104-55 40-136 40-259c0-155 85-264 238-271 93-4 162 59 197 118v-318h68v642c0 19 8 28 24 28V0c-42 13-84-13-84-50v-51zM110-259c0 122 73 209 194 209 86 0 152-53 171-129v-161c-31-69-87-130-180-130-119 0-185 91-185 211",
    id: "am"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 0v-521h68V0H75zm0-630v-100h68v100H75",
    id: "an"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165-113c-1 73 106 62 142 33l18 55C293-10 255 6 207 6 141 6 97-28 97-94v-373H25v-54h72v-176h68v176h120v54H165v354",
    id: "ao"
  }), /*#__PURE__*/React.createElement("g", {
    id: "j"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04222222222222221,0,0,0.04222222222222221,0,0)",
    xlinkHref: "#al"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04222222222222221,0,0,0.04222222222222221,24.699999999999992,0)",
    xlinkHref: "#am"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04222222222222221,0,0,0.04222222222222221,50.96222222222221,0)",
    xlinkHref: "#an"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04222222222222221,0,0,0.04222222222222221,60.16666666666665,0)",
    xlinkHref: "#ao"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M33-152c0-163 233-183 372-130 12-119-39-199-147-197-69 1-119 29-167 62l-24-45c67-45 133-68 196-68 129-1 210 79 210 207v235c0 19 8 28 25 28V0c-44 11-80-5-82-46l-2-41c-42 57-115 97-208 97C103 10 33-50 33-152zm65-5C94-6 333-21 387-115c28-21 15-79 18-124-100-44-304-44-307 82",
    id: "ap"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358-530c125 0 154 99 155 225V0h-68v-291c-1-106-21-177-112-177-102 0-161 68-190 149V0H75v-521h62v118c37-69 120-127 221-127",
    id: "aq"
  }), /*#__PURE__*/React.createElement("g", {
    id: "k"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04222222222222221,0,0,0.04222222222222221,0,0)",
    xlinkHref: "#ap"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04222222222222221,0,0,0.04222222222222221,23.011111111111106,0)",
    xlinkHref: "#aq"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04222222222222221,0,0,0.04222222222222221,47.62666666666665,0)",
    xlinkHref: "#am"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M139-396c34-70 99-132 196-127v62c-97 3-167 59-192 137V0H75v-521h64v125",
    id: "ar"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522-120C485-42 411 10 300 10 138 10 39-100 39-262c0-161 99-268 260-268 168 0 260 118 257 294H110c14 112 76 194 193 194 79 0 133-38 160-94zm-30-168c-9-131-125-225-264-175-69 25-111 88-119 175h383",
    id: "as"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65-241v-63h292v63H65",
    id: "at"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577-260c0 156-83 264-236 270-95 4-160-57-198-118v321H75v-734h61v101c45-83 181-146 293-88 84 43 148 126 148 248zm-434 79c33 69 84 131 179 131 119 0 186-90 186-210 0-122-73-210-194-210-87 0-151 54-171 129v160",
    id: "au"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556-259c0 160-98 269-259 269S39-99 39-259c0-125 67-206 155-249 61-29 145-29 206 0 89 43 156 123 156 249zM297-470c-119 0-189 90-189 212 0 121 70 208 189 208s190-88 190-210c0-121-71-210-190-210",
    id: "av"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438-202C513-35 297 54 129-10 91-25 57-43 29-68l31-46c52 41 104 69 187 72 88 4 165-51 128-134-69-79-256-49-311-144-7-14-11-31-11-52-9-188 290-194 383-87l-33 40c-59-86-330-92-278 71 72 78 268 45 313 146",
    id: "aw"
  }), /*#__PURE__*/React.createElement("g", {
    id: "l"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04222222222222221,0,0,0.04222222222222221,0,0)",
    xlinkHref: "#ar"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04222222222222221,0,0,0.04222222222222221,13.722222222222218,0)",
    xlinkHref: "#as"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04222222222222221,0,0,0.04222222222222221,38.50666666666665,0)",
    xlinkHref: "#at"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04222222222222221,0,0,0.04222222222222221,56.324444444444424,0)",
    xlinkHref: "#au"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04222222222222221,0,0,0.04222222222222221,82.37555555555554,0)",
    xlinkHref: "#ar"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04222222222222221,0,0,0.04222222222222221,96.09777777777775,0)",
    xlinkHref: "#av"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04222222222222221,0,0,0.04222222222222221,121.21999999999997,0)",
    xlinkHref: "#au"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04222222222222221,0,0,0.04222222222222221,147.27111111111108,0)",
    xlinkHref: "#av"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04222222222222221,0,0,0.04222222222222221,172.3933333333333,0)",
    xlinkHref: "#aw"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04222222222222221,0,0,0.04222222222222221,192.95555555555555,0)",
    xlinkHref: "#as"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M708-530c122-6 127 117 104 225L747 0h-68c23-125 58-238 71-372 12-124-128-108-187-54-32 29-64 66-84 108L412 0h-68c23-125 61-240 72-374 10-121-123-108-187-53-33 29-63 63-85 108L77 0H9l110-521h63l-26 118c46-65 117-125 214-127 82-2 119 52 119 136 48-73 117-131 219-136",
    id: "ax"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119-521h68L77 0H9zm45-209h68l-21 100h-68",
    id: "ay"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392-530c121-7 122 121 100 225L428 0h-68c23-124 61-242 72-376 11-125-135-98-196-50-36 28-71 64-92 107L77 0H9l110-521h63l-26 118c54-66 123-120 236-127",
    id: "az"
  }), /*#__PURE__*/React.createElement("g", {
    id: "m"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.05111111111111108,0,0,0.05111111111111108,0,0)",
    xlinkHref: "#O"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.05111111111111108,0,0,0.05111111111111108,32.35333333333331,0)",
    xlinkHref: "#R"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.05111111111111108,0,0,0.05111111111111108,62.91777777777774,0)",
    xlinkHref: "#ax"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.05111111111111108,0,0,0.05111111111111108,107.79333333333327,0)",
    xlinkHref: "#ay"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.05111111111111108,0,0,0.05111111111111108,118.67999999999992,0)",
    xlinkHref: "#az"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M619-525c0 135-86 220-200 251L526 0h-79L345-262H149L93 0H24l151-710h285c105 6 159 80 159 185zm-72 8c0-73-33-131-104-131H231l-69 324h219c103-11 166-87 166-193",
    id: "aA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363-184C323-119 278-58 228 0h-73L53-521h70l84 458c52-62 97-127 137-198l-60-260h70l38 173c27-56 49-112 67-173h65c-28 94-66 178-112 259l43 199c104-132 193-287 242-458h66C712-346 616-172 476 0h-73",
    id: "aB"
  }), /*#__PURE__*/React.createElement("g", {
    id: "n"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.05111111111111108,0,0,0.05111111111111108,0,0)",
    xlinkHref: "#aA"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.05111111111111108,0,0,0.05111111111111108,31.535555555555536,0)",
    xlinkHref: "#Q"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.05111111111111108,0,0,0.05111111111111108,58.26666666666663,0)",
    xlinkHref: "#P"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.05111111111111108,0,0,0.05111111111111108,83.36222222222217,0)",
    xlinkHref: "#ay"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.05111111111111108,0,0,0.05111111111111108,94.24888888888883,0)",
    xlinkHref: "#Q"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.05111111111111108,0,0,0.05111111111111108,120.97999999999992,0)",
    xlinkHref: "#aB"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M175-710h69l-67 316h395l67-316h70L558 0h-70l71-332H164L93 0H24",
    id: "aC"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M119-521h68L77 0H9zm45-209h68l-21 100h-68",
    id: "aD"
  }), /*#__PURE__*/React.createElement("g", {
    id: "o"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04666666666666665,0,0,0.04666666666666665,0,0)",
    xlinkHref: "#aC"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04666666666666665,0,0,0.04666666666666665,33.08666666666665,0)",
    xlinkHref: "#aD"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04666666666666665,0,0,0.04666666666666665,43.02666666666665,0)",
    xlinkHref: "#z"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04666666666666665,0,0,0.04666666666666665,57.81999999999998,0)",
    xlinkHref: "#D"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M530-223C530-61 406 6 241 6 135 6 52-28-9-97l47-57c38 56 120 98 218 98 110 0 197-43 197-146 0-118-161-108-251-148-55-25-103-50-103-125 0-163 123-236 289-240 92-2 156 32 199 82l-45 56c-27-46-92-77-168-76-117 2-199 44-199 156s155 98 240 135c61 27 115 56 115 139",
    id: "aE"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M394-118C343-50 264 4 159 10 43 17 24-102 48-215l66-306h67c-23 123-59 241-72 372C96-24 242-37 308-89c36-28 70-62 93-104l70-328h68c-31 148-94 291-94 444 0 11 6 17 19 17L451 0c-45 10-82-9-69-59 5-19 7-36 12-59",
    id: "aF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M392-530c121-7 122 121 100 225L428 0h-68c23-124 61-242 72-376 11-125-135-98-196-50-36 28-71 64-92 107L77 0H9l110-521h63l-26 118c54-66 123-120 236-127",
    id: "aG"
  }), /*#__PURE__*/React.createElement("g", {
    id: "p"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04666666666666665,0,0,0.04666666666666665,0,0)",
    xlinkHref: "#aE"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04666666666666665,0,0,0.04666666666666665,27.066666666666656,0)",
    xlinkHref: "#G"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04666666666666665,0,0,0.04666666666666665,42.04666666666665,0)",
    xlinkHref: "#aF"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04666666666666665,0,0,0.04666666666666665,68.59999999999998,0)",
    xlinkHref: "#ak"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04666666666666665,0,0,0.04666666666666665,96.50666666666663,0)",
    xlinkHref: "#D"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04666666666666665,0,0,0.04666666666666665,121.42666666666662,0)",
    xlinkHref: "#aG"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04666666666666665,0,0,0.04666666666666665,147.27999999999994,0)",
    xlinkHref: "#G"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M405-710c171 3 259 103 259 272 0 205-103 337-247 405C314 16 167-5 24 0l151-710h230zm187 283c0-136-66-221-201-221H231L106-62c110-3 220 11 296-30 112-60 190-171 190-335",
    id: "aH"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M193-63c103-132 191-287 239-458h66C448-346 353-172 214 0h-73L58-521h71",
    id: "aI"
  }), /*#__PURE__*/React.createElement("g", {
    id: "q"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04666666666666665,0,0,0.04666666666666665,0,0)",
    xlinkHref: "#aH"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04666666666666665,0,0,0.04666666666666665,32.19999999999999,0)",
    xlinkHref: "#D"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04666666666666665,0,0,0.04666666666666665,56.60666666666664,0)",
    xlinkHref: "#aI"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04666666666666665,0,0,0.04666666666666665,79.1933333333333,0)",
    xlinkHref: "#D"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04666666666666665,0,0,0.04666666666666665,104.11333333333329,0)",
    xlinkHref: "#ai"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04666666666666665,0,0,0.04666666666666665,116.19999999999996,0)",
    xlinkHref: "#A"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04666666666666665,0,0,0.04666666666666665,142.93999999999994,0)",
    xlinkHref: "#B"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04666666666666665,0,0,0.04666666666666665,170.61333333333326,0)",
    xlinkHref: "#D"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04666666666666665,0,0,0.04666666666666665,195.53333333333325,0)",
    xlinkHref: "#z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#3a414a",
    d: "M44-476c67-11 125-55 162-95h137v450h127V0H64v-121h142v-303c-37 37-95 67-162 73v-125",
    id: "aJ"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.0513333333333333,0,0,0.0513333333333333,0,0)",
    xlinkHref: "#aJ",
    id: "r"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3a414a",
    d: "M294-581c124 0 215 51 215 170 0 180-216 173-292 290h303V0H38C27-211 193-250 320-329c24-15 43-29 43-62 0-45-41-75-93-73-69 2-107 39-140 77l-86-99c57-53 140-95 250-95",
    id: "aK"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.0513333333333333,0,0,0.0513333333333333,0,0)",
    xlinkHref: "#aK",
    id: "s"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3a414a",
    d: "M508-399c0 90-51 145-127 163 80 13 142 85 139 178-5 144-110 205-260 205-106 0-183-36-232-96l76-95c34 42 77 69 152 69S381-1 381-73c0-88-76-113-177-108v-100c89 7 159-23 161-98 1-57-44-81-101-81-68 1-115 35-142 80l-84-94c47-65 132-102 241-102 128 0 229 52 229 177",
    id: "aL"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04911111111111108,0,0,0.04911111111111108,0,0)",
    xlinkHref: "#aL",
    id: "t"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3a414a",
    d: "M312 127V-22H20v-119l335-430h91v429h88v120h-88v149H312zM154-142h173v-226",
    id: "aM"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04911111111111108,0,0,0.04911111111111108,0,0)",
    xlinkHref: "#aM",
    id: "u"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3a414a",
    d: "M197-290c19-19 52-30 93-29 143 5 233 85 233 228 0 155-105 236-261 240C154 152 68 98 29 26l77-80c31 45 88 84 157 85 70 1 123-48 123-119 0-67-49-117-115-116-48 0-87 25-107 56H47c27-144 53-271 82-423h350v122H226",
    id: "aN"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04911111111111108,0,0,0.04911111111111108,0,0)",
    xlinkHref: "#aN",
    id: "v"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599-487c0 115-61 190-158 213L615 0h-79L369-262H159V0H89v-710h300c129 10 210 95 210 223zm-70 0c0-92-54-161-144-161H159v324h232c90-6 138-72 138-163",
    id: "aO"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231 0L19-521h70L268-63l180-458h66L302 0h-71",
    id: "aP"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M731-521h67L574 0h-56L406-266 295 0h-56L15-521h66L271-70l99-238-89-212h57l68 170 68-170h58l-89 212 99 238",
    id: "aQ"
  }), /*#__PURE__*/React.createElement("g", {
    id: "w"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04466666666666662,0,0,0.04466666666666662,0,0)",
    xlinkHref: "#aO"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04466666666666662,0,0,0.04466666666666662,28.49733333333331,0)",
    xlinkHref: "#as"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04466666666666662,0,0,0.04466666666666662,54.09133333333329,0)",
    xlinkHref: "#aP"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04466666666666662,0,0,0.04466666666666662,77.89866666666659,0)",
    xlinkHref: "#an"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04466666666666662,0,0,0.04466666666666662,87.63599999999991,0)",
    xlinkHref: "#as"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04466666666666662,0,0,0.04466666666666662,113.2299999999999,0)",
    xlinkHref: "#aQ"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M309-710h59L663 0h-74l-92-222H178L87 0H12zm172 433L338-628 193-277h288",
    id: "aR"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179 6C117 6 77-32 78-95v-635h68v612c-6 63 67 74 115 51l12 55c-21 9-65 18-94 18",
    id: "aS"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301 10C138 10 39-100 39-262s98-263 261-268c103-3 178 53 212 124l-66 21c-26-48-79-85-149-85-120 0-189 85-189 208S178-50 298-50c74 0 129-36 152-89l67 20C482-42 410 10 301 10",
    id: "aT"
  }), /*#__PURE__*/React.createElement("g", {
    id: "x"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04466666666666662,0,0,0.04466666666666662,0,0)",
    xlinkHref: "#aR"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04466666666666662,0,0,0.04466666666666662,30.194666666666635,0)",
    xlinkHref: "#au"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04466666666666662,0,0,0.04466666666666662,57.75399999999994,0)",
    xlinkHref: "#au"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04466666666666662,0,0,0.04466666666666662,85.31333333333323,0)",
    xlinkHref: "#aS"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04466666666666662,0,0,0.04466666666666662,97.46266666666654,0)",
    xlinkHref: "#an"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04466666666666662,0,0,0.04466666666666662,107.19999999999989,0)",
    xlinkHref: "#aT"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04466666666666662,0,0,0.04466666666666662,131.72199999999984,0)",
    xlinkHref: "#ap"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04466666666666662,0,0,0.04466666666666662,155.88666666666649,0)",
    xlinkHref: "#ao"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04466666666666662,0,0,0.04466666666666662,170.8499999999998,0)",
    xlinkHref: "#an"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04466666666666662,0,0,0.04466666666666662,180.5873333333331,0)",
    xlinkHref: "#av"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04466666666666662,0,0,0.04466666666666662,207.1639999999998,0)",
    xlinkHref: "#aq"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(0.04466666666666662,0,0,0.04466666666666662,233.2046666666664,0)",
    xlinkHref: "#aw"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCcWorkflowoverviewv2);
export default __webpack_public_path__ + "static/media/CC Workflow overview v2.8d52a2fed5743ab1c331cd079bcdbda3.svg";
export { ForwardRef as ReactComponent };